import { createContext, PropsWithChildren, useState, useEffect, useContext } from 'react';
import { Blockfrost, Lucid, WalletApi } from 'lucid-cardano';
import { useLocalStorage } from 'react-use';
import axios from 'axios';

interface WalletConnectContextValues {
  api: WalletApi | null;
  lucid: Lucid | null;
  activeWallet: string;
  accumulating: boolean;
  myWalletAddress: string;
  enableWallet: (name: string) => Promise<void> | void;
  disableWalletAddress: () => Promise<void> | void;
  setMyWalletAddress: (newValue: string) => void;
  walletConnected?: boolean;
}

export const WalletConnectContext = createContext<WalletConnectContextValues>({
  api: null,
  lucid: null,
  activeWallet: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  enableWallet: () => { },
  myWalletAddress: '',
  accumulating: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  disableWalletAddress: () => { },
  setMyWalletAddress: () => { },
});

export const WalletConnectProvider = ({ children }: PropsWithChildren) => {
  const [api, setApi] = useState<WalletApi | null>(null);
  const [lucid, setLucid] = useState<Lucid | null>(null);
  const [accumulating, setAccumulating] = useState(false);
  const [myWalletAddress, setMyWalletAddress] = useState<string>();
  const [walletConnected, setWalletConnected] = useState<boolean>();
  // const { setMyWalletAddress } = useContext(GlobalProvider);

  const [activeWalletName, setActiveWalletName] = useLocalStorage('active-wallet-name', '');
  // @ts-ignore

  const disableWalletAddress = () => {
    setMyWalletAddress('');
    setActiveWalletName('');
  };

  const enableWallet = async (name: string) => {
    const api = await window.cardano[name].enable();
    const newLucid = await Lucid.new(
      new Blockfrost(
        "https://cardano-mainnet.blockfrost.io/api/v0",
        "mainnetEfwpIEpJO16ARprn8lHi5rz9yof4EklA"
      ),
      "Mainnet"
    );
    newLucid.selectWallet(api);
    setApi(api);
    setActiveWalletName(name);
    setLucid(newLucid);
    const my_wallet_address = await newLucid.wallet.address();
    // const my_wallet_address = 'addr1qy8w59meuas2uvepvvp5j4f9rkajmfpuxzr4cr5jm2snxw2hfd5cvn8lt3agxdfdf8vnxwp6kze4pyhwmcshqpemvrls8wvere'
    
    setMyWalletAddress(my_wallet_address);

    const { data } = await axios.get(
      `https://rz5lmdjzaa.execute-api.eu-west-2.amazonaws.com/default/isAddressRegistered?address=${my_wallet_address}`
    );
    setAccumulating(data);
  };
  useEffect(() => {
    const initializeWallet = async () => {
      if (activeWalletName) {
        const isEnabled = await window.cardano[activeWalletName].isEnabled();

        if (isEnabled) {
          setWalletConnected(true)
          enableWallet(activeWalletName);
        }else{
          setWalletConnected(true)
        }
      }
    };

    initializeWallet();
  }, [activeWalletName]);

  useEffect(() => {
  }, [walletConnected])


  return (
    <WalletConnectContext.Provider
      value={{
        api,
        lucid,
        activeWallet: activeWalletName ?? '',
        enableWallet,
        accumulating,
        myWalletAddress,
        disableWalletAddress,
        setMyWalletAddress,
        walletConnected
      }}
    >
      {children}
    </WalletConnectContext.Provider>
  );
};

export const useWalletConnect = () => useContext(WalletConnectContext);